import styled from 'styled-components';

export const IconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
